import React from 'react';

import Button from 'ui/Button';
import Icon, { IconType } from 'ui/Icon';
import { Text } from 'ui/Typography';

type Props = {
  label: string;
  icon: IconType;
  onClick: () => void;
};

const SocialSignInButton: React.FC<Props> = ({ label, icon, onClick }) => (
  <Button
    background="white"
    border="1px solid"
    borderColor="gray.400"
    color="gray.800"
    fontWeight="medium"
    onClick={onClick}
    variant="neutral-ghost"
  >
    <Icon color="gray.600" icon={icon} />
    <Text ml={3} w="100%">
      {label}
    </Text>
  </Button>
);

export default SocialSignInButton;
